<template>
  <v-container fluid class="a-sor-detail" v-if="aSor">
    <v-row class="flex-grow-0">
      <v-btn
        text
        x-small
        color="primary"
        exact
        :to="{
          name: 'contract-detail',
          params: { contractId: aSor.contract.id },
        }"
      >
        &lt;&lt; {{ aSor.contract.name }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" small class="ml-4" @click="getASor">
        <v-icon small>fas fa-sync-alt</v-icon>
      </v-btn>
    </v-row>

    <v-row class="sor-info-wrapper">
      <v-col>
        <div class="sor-info">
          <h3>{{ aSor.name }}</h3>
          <v-btn
            v-if="haveSpecialPermission"
            color="primary"
            small
            @click="goToRbuSection"
            >RBU</v-btn
          >
        </div>
      </v-col>
    </v-row>

    <!--Excel-->
    <v-row class="a-sor-detail-row mt-8 rounded">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("a_sor.excel") }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="!aSor.finalised_at"
          @click="downloadTemplate"
        >
          Download Template
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="!aSor.finalised_at"
          @click="importASoR"
        >
          Upload
        </v-btn>
        <span class="a-sor-finalised-div" v-if="aSor.finalised_at">
          {{ $t("sor.finalised") }}
          <v-icon color="#5BC23F" small>mdi-check</v-icon>
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="aSor.excel && !aSor.finalised_at"
          @click="finaliseExcel"
        >
          Finalise
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               small-->
        <!--               class="ml-4"-->
        <!--               v-if="aSor.finalised_at"-->
        <!--               :disabled="aSor.action_input_finalised_at"-->
        <!--               @click="unfinaliseExcel">-->
        <!--          {{ $t('sor.un_finalise') }}-->
        <!--        </v-btn>-->
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table
          :items="excelItems"
          :headers="excelHeaders"
          hide-default-footer
        >
          <template #no-data> No A-SoR Excel Uploaded </template>
          <template #item.excel.created_at="{ value }">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at="{ value }">
            {{ value ? $parseDate(value) : "" }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-btn text color="primary" @click="$downloadFile(item.excel.id)">
                Download
              </v-btn>
              <v-btn
                text
                color="primary"
                v-if="!item.finalised_at"
                @click="previewExcel(item)"
              >
                PDF
                <v-icon class="mr-2" v-if="!item.finalised_pdf"
                  >mdi-file-alert
                </v-icon>
              </v-btn>
              <v-btn
                text
                color="primary"
                v-if="item.finalised_at"
                @click="$downloadFile(item.finalised_pdf)"
              >
                PDF
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!--A-SoR ACTION Input-->
    <v-row class="a-sor-disable-row mt-8 rounded" v-if="!aSor.finalised_at">
      <v-col>
        <span class="font-weight-bold mr-8">{{
          $t("a_sor.action_input")
        }}</span>
        {{ $t("a_sor.action_input_not_available") }}
      </v-col>
    </v-row>
    <v-row class="a-sor-detail-row mt-8 rounded" v-if="aSor.finalised_at">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("a_sor.action_input") }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="!aSor.action_input_finalised_at"
          @click="regenActionInput"
        >
          REGENERATE
        </v-btn>
        <span class="a-sor-finalised-div" v-if="aSor.action_input_finalised_at">
          {{ $t("sor.finalised") }}
          <v-icon color="#5BC23F" small>mdi-check</v-icon>
        </span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          :disabled="!aSor.action_input"
          @click="$downloadFile(aSor.action_input.id)"
        >
          {{ $t("sor.download_action_input") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          :disabled="!aSor.action_input"
          v-if="!aSor.action_input_finalised_at"
          @click="importActionInput"
        >
          {{ $t("sor.import_action_input") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          small
          class="ml-4"
          :disabled="!aSor.action_input"
          v-if="!aSor.action_input_finalised_at"
          @click="finaliseActionInput"
        >
          {{ $t("sor.finalise") }}
        </v-btn>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table
          :items="actionItems"
          :headers="actionHeaders"
          hide-default-header
          hide-default-footer
        >
          <template #no-data>
            {{ $t("sor.action_input_being_generated") }}
          </template>
          <template #item.created_at="{ value }">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at>
            {{
              aSor.action_input_finalised_at
                ? $parseDate(aSor.action_input_finalised_at)
                : ""
            }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!--Combined ACTION Input-->
    <v-row
      class="a-sor-disable-row mt-8 rounded"
      v-if="!aSor.action_input_finalised_at"
    >
      <v-col>
        <span class="font-weight-bold mr-8">{{
          $t("a_sor.finalised_action_input")
        }}</span>
        {{ $t("a_sor.finalised_action_input_not_available") }}
      </v-col>
    </v-row>
    <v-row
      class="a-sor-detail-row mt-8 rounded"
      v-if="aSor.action_input_finalised_at"
    >
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{
          $t("a_sor.finalised_action_input")
        }}</span>
        <span class="a-sor-finalised-div">
          {{ $t("sor.finalised") }}
          <v-icon color="#5BC23F" small>mdi-check</v-icon>
        </span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          :disabled="!aSor.finalised_action_input"
          @click="$downloadFile(aSor.finalised_action_input.id)"
        >
          {{ $t("sor.download_action_input") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          :disabled="!aSor.reference_table"
          @click="$downloadFile(aSor.reference_table)"
        >
          {{ $t("sor.download_reference_table") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table
          :items="combineActionItems"
          :headers="actionHeaders"
          hide-default-header
          hide-default-footer
        >
          <template #no-data>
            {{ $t("sor.action_input_being_generated") }}
          </template>
          <template #item.created_at="{ value }">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at>
            {{
              aSor.action_input_finalised_at
                ? $parseDate(aSor.action_input_finalised_at)
                : ""
            }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import SorList from "@/components/sor/SorList";
import { ACTION_TYPES } from "@/store/types";
import SectionList from "@/components/section/SectionList";
import ImportActionInputDialog from "@/components/sor/ImportActionInputDialog";
import { PERMISSIONS, SPECIAL_PERMISSIONS } from "@/constants";
import ImportContractASoRDialog from "@/components/contract/ImportContractASoRDialog";
import ContractASorPreviewModal from "@/components/contract/ContractASorPreviewModal";

export default {
  name: "ASoR",
  components: { SectionList, SorList },
  setup(props, { root }) {
    const aSor = ref(null);
    const getASor = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/",
        params: { a_sor_id: root.$route.params.aSorId },
      });

      if (response.body.success) {
        aSor.value = response.body.a_sor;
      }
    };

    const haveSpecialPermission = computed(() => {
      return root.$store.getters.hasSpecialPermission(
        SPECIAL_PERMISSIONS.ASOR_RBU
      );
    });

    const downloadTemplate = async function () {
      let link = document.createElement("a");
      link.href = "asor_input_template.xlsx";
      link.download = "a_sor_input_template.xlsx";
      link.click();
    };
    const importASoR = async function () {
      await root.$dialog.showAndWait(ImportContractASoRDialog, {
        aSorId: root.$route.params.aSorId,
        showClose: false,
        persistent: true,
      });
      await getASor();
    };

    const excelItems = computed(() => {
      if (aSor.value && aSor.value.excel) {
        return [aSor.value];
      }

      return [];
    });
    const excelHeaders = ref([
      { text: "Last Update", value: "excel.created_at", width: 150 },
      { text: "Filename", value: "excel.filename" },
      { text: "Finalised At", value: "finalised_at", width: 150 },
      { text: "", value: "actions", sortable: false, width: 100 },
    ]);
    const previewExcel = async function (item) {
      await root.$dialog.showAndWait(ContractASorPreviewModal, {
        sorId: item.id,
        aSor: item,
        width: "70vw",
        showClose: false,
        persistent: true,
        scrollable: true,
      });

      await getASor();
    };
    const finaliseExcel = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("a_sor.finalise_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/finalise/",
          params: { a_sor_id: root.$route.params.aSorId },
        });

        if (response.body.success) {
          await getASor();
        }
      }
    };
    const unfinaliseExcel = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("a_sor.un_finalise_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/unfinalise/",
          params: { a_sor_id: root.$route.params.aSorId },
        });

        if (response.body.success) {
          await getASor();
        }
      }
    };

    const actionItems = computed(() => {
      if (aSor.value && aSor.value.action_input) {
        return [aSor.value.action_input];
      }

      return [];
    });
    const combineActionItems = computed(() => {
      if (aSor.value && aSor.value.finalised_action_input) {
        return [aSor.value.finalised_action_input];
      }

      return [];
    });
    const actionHeaders = ref([
      {
        text: root.$t("action_input.created_at"),
        value: "created_at",
        width: 150,
      },
      { text: root.$t("action_input.filename"), value: "filename" },
      {
        text: root.$t("action_input.finalised_at"),
        value: "finalised_at",
        width: 150,
      },
    ]);
    const regenActionInput = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("a_sor.regen_action_input_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/regen_action/",
          params: { a_sor_id: root.$route.params.aSorId },
        });

        if (response.body.success) {
          await getASor();
        }
      }
    };
    const importActionInput = async function () {
      await root.$dialog.showAndWait(ImportActionInputDialog, {
        aSoRId: root.$route.params.aSorId,
        showClose: false,
        persistent: true,
      });
      await getASor();
    };
    const finaliseActionInput = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("sor.finalise_action_input_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/finalise_action_input/",
          params: { a_sor_id: root.$route.params.aSorId },
        });

        if (response.body.success) {
          await getASor();
        }
      }
    };
    const unfinaliseActionInput = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("sor.unfinalise_action_input_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/unfinalise_action_input/",
          params: { a_sor_id: root.$route.params.aSorId },
        });

        if (response.body.success) {
          await getASor();
        }
      }
    };

    const goToRbuSection = async function () {
      root.$router.push({
        name: "a-sor-rbu-section",
        params: { aSorId: root.$route.params.aSorId },
      });
    };

    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    onMounted(() => {
      getASor();
    });

    return {
      aSor,
      getASor,
      downloadTemplate,

      importASoR,

      excelItems,
      excelHeaders,
      previewExcel,
      finaliseExcel,
      unfinaliseExcel,

      actionItems,
      combineActionItems,
      actionHeaders,
      regenActionInput,
      importActionInput,
      finaliseActionInput,
      unfinaliseActionInput,

      refreshTrigger,
      refresh,

      PERMISSIONS,
      goToRbuSection,
      haveSpecialPermission,
    };
  },
};
</script>

<style lang="less">
.a-sor-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .sor-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .sor-info {
      // flex: 1 1 0;
      display: flex;
      gap: 1rem;
    }

    .sor-info-btns {
      flex: 0 0 auto;
      width: 200px;
    }
  }

  .a-sor-disable-row {
    flex: 0 0 auto;
    background-color: rgba(238, 119, 122, 0.1);
  }

  .a-sor-finalised-div {
    border: solid 1px #5bc23f;
    border-radius: 12px;
    color: #5bc23f;
    background-color: rgba(91, 194, 63, 0.2);
    padding: 2px 8px;
    margin-left: 8px;
  }

  .a-sor-detail-row {
    flex: 0 0 auto;
    background-color: #ffffff;

    &.finalised {
      background-color: #ffffff88;
    }
  }
}
</style>
